import { MainTheme } from '@uma/react-commons/dist/index';
import { Card } from '@veneer/core';
import tokens from '@veneer/tokens';
import styled from 'styled-components';
import { Card as CustomCard } from '@uma/react-commons/dist/index';

export const Section = styled(Card)`
  display: flex;
  padding: ${tokens.layout.size4} !important;
  flex-direction: column;
  gap: ${tokens.layout.size2};

  && {
    border-radius: ${tokens.layout.size4};
  }
`;

export const CardContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: flex-start;
  padding-top: ${tokens.layout.size2};
  @media screen and (max-width: ${tokens.layout.smMin}) {
    grid-template-columns: 1fr;
    gap: ${tokens.layout.size2};
  }
`;

export const RowIcon = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.layout.size2};
  width: 100%;
  & > .logo-instant-ink > img {
    height: 15px;
    width: 80px;
  }
  & > .custom-image > img {
    height: 55px;
    width: 72px;
  }

  > span {
    width: 100%;
  }
`;

export const Label = styled.h2`
  color: ${tokens.color.gray6};
  font-size: ${tokens.typography.size4};
  line-height: ${tokens.typography.size6};
`;

export const Link = styled.a`
  color: #024ad8 !important;
  border-radius: ${tokens.layout.size1};
  outline: none;
  box-shadow: none;
  transition: none;
  &:focus-visible {
    outline: #001cb0 solid 2px;
    outline-offset: 2px;
  }
`;

export const Row = styled.div<{ $flexDirection: 'column' | 'row' }>`
  display: flex;
  flex-direction: ${({ $flexDirection }) => $flexDirection};
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
`;

export const History = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.layout.size2};
  align-items: flex-start;
  align-self: end;
`;

export const HistoryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.layout.size2};
  align-items: flex-start;

  b {
    font-size: 16px;
  }
`;

export const Gap8 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${tokens.layout.size2};
`;

export const EmptyContent = styled.div`
  padding-top: ${tokens.layout.size2};
`;

export const Notification = styled.div`
  @media ${MainTheme.mediaQueries.mobile} {
    position: relative;

    && div {
      display: grid;
    }

    && svg {
      position: absolute;
      width: ${tokens.layout.size6};
      height: ${tokens.layout.size6};
    }

    && .vn-notification__text {
      display: flex;
      padding-left: ${tokens.layout.size8};
      font-size: ${tokens.typography.size1};
    }

    && button {
      flex-direction: column;
      align-items: flex-end;
      flex-wrap: wrap;
      padding-right: ${tokens.layout.size5};

      span {
        font-size: ${tokens.typography.size1};
      }
    }
  }
`;

export const ContainerPaymentHistory = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const StyledCard = styled(CustomCard)`
  a:focus-visible {
    outline: 2px solid #001cb0;
    outline-offset: -2px !important;
  }
`;
